import { Router } from '@angular/router';
import { AuthService } from './../../../../services/auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from "../../../../models/user.model";
import {CommerciauxService} from "../../../../services/commerciaux.service";
import Swal from "sweetalert2";
import {UserService} from "../../../../services/user.service";
import * as XLSX from "xlsx";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-commerciaux',
  templateUrl: './commerciaux.component.html',
  styleUrls: ['./commerciaux.component.scss']
})
export class CommerciauxComponent implements OnInit {

  commerciaux: User[] = [];
  commerciauxWithCode: User[] = [];
  commerciauxTmp: User[] = [];

  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;

  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;
  sorted4 = false;
  sorted5 = false;
  sorted6 = false;
  sorted9 = false;

  perPage = 10;

  constructor(private commerciauxService : CommerciauxService,private datePipe: DatePipe,
              private userService : UserService, private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.loadCommerciaux();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  loadCommerciaux = () => {
    this.commerciaux = [];
    this.commerciauxService.getCommerciaux().subscribe(data => {
      this.commerciauxWithCode = data;
      this.commerciauxWithCode.forEach(user => {
        user.sellerAuthorization = user.sellerAuthorization == null ? 'Client' : user.sellerAuthorization;

        this.commerciauxService.getCommerciauxWithCode(user.username).subscribe(rs=>{
          user.commercialID = rs.commercialID;
          this.commerciaux.push(user);
          this.commerciauxTmp.push(user);
          //console.log(this.commerciaux)
        });
      });
    }, (err) => {
    });
  }

  disableEndDate = true;
  displayError = false;
  //Récupération de la date de début
  getBeginDate(event:any){
    this.beginDate=event.target.value;
    if(this.beginDate){
      this.disableEndDate = false;
      if(this.beginDate > this.endDate){
        this.displayError = true;
      }else{
        this.displayError = false;
      }
    }else{
      this.disableEndDate = true;
    }
  }
  // Récupération de la date de fin
  getEndDate(event){
    this.endDate=event.target.value;
  }

  searchFilter(KeyboardEvent) {
    if(KeyboardEvent.target.value){
      this.commerciaux = this.commerciaux.filter(value =>
        value?.commercialID?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.firstname?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.lastname?.toLowerCase().includes(this.search.toUpperCase()) ||
        value?.username?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.gender?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.address?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCity?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.residenceCountry?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.nationality?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.sellerAuthorization?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.email?.toUpperCase().includes(this.search.toUpperCase()) ||
        value?.firstname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.firstname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase()) ||
        value?.lastname?.toUpperCase().includes(this.search.split(" ")[0].toUpperCase()) &&
        value?.lastname?.toUpperCase().includes(this.search.split(" ")[1].toUpperCase())
      );
    }else{
      this.commerciaux = this.commerciauxTmp;
    }

    //console.log("Commerciaux", this.commerciaux);
  }

  activeAccount(currentUser: User) {
    currentUser.activated = true;
    currentUser.profilPhoto = null;
    currentUser.photoSelfie = null;
    currentUser.iphotoVerso = null;
    currentUser.iphotoRecto = null;
    this.userService.updateUser(currentUser).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le compte de l\'utilisateur  ' + currentUser.firstname + ' a bien été activé',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadCommerciaux();
    });
  }

  lockAccount(currentUser: User) {
    currentUser.activated = false;
    currentUser.profilPhoto = null;
    currentUser.photoSelfie = null;
    currentUser.iphotoVerso = null;
    currentUser.iphotoRecto = null;
    this.userService.updateUser(currentUser).subscribe(rs => {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le compte de l\'utilisateur  ' + currentUser.firstname + ' a bien été désactivé',
        showConfirmButton: false,
        timer: 1500
      });
      this.loadCommerciaux();
    });
  }

  abortCommercial(id:any) {
    let newCommercial;
    this.userService.getidUser(id).subscribe(nwuser => {
      newCommercial=nwuser;
      Swal.fire({
        title: 'Suppression commercial',
        text: 'Voulez-vous supprimer '+newCommercial.firstname +' '+ newCommercial.lastname+' de la liste des commerciaux ?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'OUI',
        denyButtonText: `NON`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.userService.abortUserToBecomeCommercial(id).subscribe(rs => {
              Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: newCommercial.firstname +' '+ newCommercial.lastname+' a été supprimer de la liste des commerciaux.',
                showConfirmButton: false,
                timer: 3500
              });
              this.loadCommerciaux();
            },error => {
              Swal.fire({
                icon: 'error',
                position: 'top-end',
                title: error.error.errorMessage,
                showConfirmButton: false,
                timer: 3500
              })
            }
          );
        } else if (result.isDenied) {
          Swal.fire({
            icon: 'error',
            text: 'Supression annulée',
          })
        }
      });
    })
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
  }

  sort0() {
    if(this.sorted == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.commercialID > b.commercialID ? 1 : a.commercialID < b.commercialID ? -1 : 0)
      this.sorted = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.commercialID < b.commercialID ? 1 : a.commercialID > b.commercialID ? -1 : 0)
      this.sorted = false;

    }
  }

  sort1() {
    if(this.sorted1 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.username > b.username ? 1 : a.username < b.username ? -1 : 0)
      this.sorted1 = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.username < b.username ? 1 : a.username > b.username ? -1 : 0)
      this.sorted1 = false;

    }
  }
  sort2() {
    if(this.sorted2 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.lastname.toLowercase  > b.lastname.toLowercase ? 1 : a.lastname < b.lastname ? -1 : 0)
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.users.sort((a, b) => a.lastname.toLowercase  < b.lastname.toLowercase  ? 1 : a.lastname > b.lastname ? -1 : 0)
      this.sorted2 = false;
    }
  }
  sort3() {
    if(this.sorted3 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.firstname > b.firstname ? 1 : a.firstname < b.firstname ? -1 : 0)
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.firstname < b.firstname ? 1 : a.firstname > b.firstname ? -1 : 0)
      this.sorted3 = false;
    }
  }
  sort4() {
    if(this.sorted4 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.email > b.email ? 1 : a.email < b.email ? -1 : 0)
      this.sorted4 = true;
    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.email < b.email ? 1 : a.email > b.email ? -1 : 0)
      this.sorted4 = false;
    }
  }


  sort5() {
    if(this.sorted5 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
      this.sorted5 = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0)
      this.sorted5 = false;

    }
  }

  sort6() {
    if(this.sorted6 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.gender > b.gender ? 1 : a.gender < b.gender ? -1 : 0)
      this.sorted6 = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.gender < b.gender ? 1 : a.gender > b.gender ? -1 : 0)
      this.sorted6 = false;

    }
  }


  exportexcel(fileName): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);

  }


  sort9() {
    if(this.sorted9 == false) {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.sellerAuthorization > b.sellerAuthorization ? 1 : a.sellerAuthorization < b.sellerAuthorization ? -1 : 0)
      this.sorted9 = true;

    } else {
      // @ts-ignore
      this.commerciaux.sort((a, b) => a.sellerAuthorization < b.sellerAuthorization ? 1 : a.sellerAuthorization > b.sellerAuthorization ? -1 : 0)
      this.sorted9 = false;

    }
  }

  /*
 filtre par date
  */


  beginDate: string = null;
  endDate: string = null;

  filter() {
    //console.log(this.endDate)
    if (this.endDate == null || this.beginDate== null) {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Veuillez choisir une date de début et une date de fin s\'il vous plaît',
        showConfirmButton: false,
        timer: 3500
      })
      return;
    }
    if (this.endDate!= null && this.beginDate!= null && this.beginDate < this.endDate) {
      const dateString = this.endDate;
      const date = new Date(dateString);
      date.setDate(date.getDate() + 1); // ajoute 1 jour à la date
      this.endDate = this.datePipe.transform(date,'yyyy-MM-dd');
      this.commerciaux = this.commerciauxTmp;
      this.commerciaux = this.commerciaux.filter((rev) => {
        let date = this.datePipe.transform(rev.createdAt, 'yyyy-MM-dd')
        return (date >= this.beginDate &&  date  <= this.endDate);
      });
    }
  }
  resetFilter() {
    this.loadCommerciaux();
    this.beginDate = null;
    this.endDate = null;
  }

}
